import React, { PropTypes, Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, intlShape } from 'react-intl';
import SimpleField from '../SimpleField';
import { Arrows } from '@bibliocommons/base-icons';

class TagGroupField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.genreExpanded || props.toneExpanded || props.aboutExpanded || props.personalExpanded
    };
    this.expandField = this.expandField.bind(this);
  }

  expandField(e) {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      expanded: !this.state.expanded
    });
  }

  static renderExpandIcon(expanded) {
    if (expanded) {
      return <Arrows.medium.Up color="#333" className="small" />;
    }

    return <Arrows.medium.Down color="#333" className="small" />;
  }
  renderSubField(field, expanded) {
    if (typeof field === 'undefined') {
      return null;
    }
    return (
      <li key={field.get('id')} className="sub-field">
        <SimpleField
          isConjunctive
          iconName="Tag"
          label={`${field.get('id')}.field`}
          fieldId={field.get('id')}
          filters={field.get('fieldFilters')}
          hasMore={field.get('hasMore')}
          activeFilters={this.props.activeFilters}
          initialIsExpanded={expanded}
          handleToggleFilter={this.props.handleToggleFilter}
          handleCloseExpandField={this.props.handleCloseExpandField}
          handleToggleExpandedField={this.props.handleToggleExpandedField}
          handleExpandField={this.props.handleExpandField} />
      </li>
    );
  }

  renderSubFields() {
    const { genreTagField,
      toneTagField,
      aboutTagField,
      personalTagField,
      genreExpanded,
      toneExpanded,
      aboutExpanded,
    personalExpanded } = this.props;
    return (
      <ul key="TAG_GROUP" className="filter-group">
        {this.renderSubField(genreTagField, genreExpanded)}
        {this.renderSubField(toneTagField, toneExpanded)}
        {this.renderSubField(aboutTagField, aboutExpanded)}
        {this.renderSubField(personalTagField, personalExpanded)}
      </ul>
    );
  }

  render() {
    const { genreTagField,
      toneTagField,
      aboutTagField,
      personalTagField,
      intl } = this.props;

    if (genreTagField || toneTagField || aboutTagField || personalTagField) {
      return (
        <div>
          <a href="#expand-filter" onClick={this.expandField} className="field-toggle">
            <span className="field-text field-name">{intl.formatMessage({ id: 'TAGS.field' })}</span>
            { TagGroupField.renderExpandIcon(this.state.expanded) }
          </a>
          { this.state.expanded ? this.renderSubFields() : null }

        </div>
      );
    }
    return null;
  }
}
TagGroupField.propTypes = {
  genreTagField: ImmutablePropTypes.map,
  genreExpanded: PropTypes.bool,
  toneTagField: ImmutablePropTypes.map,
  toneExpanded: PropTypes.bool,
  aboutExpanded: PropTypes.bool,
  aboutTagField: ImmutablePropTypes.map,
  personalExpanded: PropTypes.bool,
  personalTagField: ImmutablePropTypes.map,
  handleToggleFilter: PropTypes.func.isRequired,
  handleCloseExpandField: PropTypes.func,
  handleToggleExpandedField: PropTypes.func.isRequired,
  handleExpandField: PropTypes.func.isRequired,
  activeFilters: ImmutablePropTypes.map,
  intl: intlShape.isRequired
};

export default injectIntl(TagGroupField);



// WEBPACK FOOTER //
// ./app/components/shared/Facets/TagGroupField/TagGroupField.jsx